import { render, staticRenderFns } from "./TrayManage.vue?vue&type=template&id=16b16c7e&scoped=true&"
import script from "./TrayManage.vue?vue&type=script&lang=js&"
export * from "./TrayManage.vue?vue&type=script&lang=js&"
import style0 from "./TrayManage.vue?vue&type=style&index=0&id=16b16c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b16c7e",
  null
  
)

export default component.exports